<script setup lang="ts">
import type { SectionItem } from "@/types/sections.types";
import SectionActionsButton from "../../sections/SectionActionsButton.vue";

const props = defineProps<{
  section: SectionItem;
  reportId: number;
  siblingCount: number;
  imageCount: number;
  selected?: boolean;
}>();

const emit = defineEmits<{
  (e: "select", sectionId: number): void;
}>();

const handleSelect = () => {
  emit("select", props.section.id);
};
</script>

<template>
  <div class="section-tree-item">
    <!-- Section row -->
    <div
      class="section-row d-flex flex-row align-items-center gap-1"
      :class="{ selected: selected }"
      @click="handleSelect"
    >
      <div class="section-path text-primary">{{ section.path }}.</div>

      <div class="section-label flex-grow-1">{{ section.title }}</div>
      <div v-if="imageCount > 0" class="image-count-badge">
        {{ imageCount }}
      </div>

      <!-- Actions dropdown -->
      <SectionActionsButton :section="section" :report-id="reportId" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/variables.scss";

.section-tree-item {
  width: 100%;
}

.section-row {
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.15s;
  width: 100%;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: var(--bs-light);
  }

  &.selected {
    background-color: rgba($primary, 0.1);
  }
}

.section-label {
  font-size: 13px;
  line-height: 1.4;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section-path {
  font-size: 10px;
  flex-shrink: 0;
}

.action-btn {
  flex-shrink: 0;
}

.image-count-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 10px;
  background-color: var(--bs-primary);
  color: white;
  min-width: 18px;
  text-align: center;
  flex-shrink: 0;
  margin-left: 8px;
}
</style>
